/**
 * Одноразовые коды из CRM приходят во фрагменте адреса: фрагмент не уходит на
 * сервер и в Referer. Забираем код при загрузке этого модуля и сразу убираем
 * из адреса — до любых запросов страницы и до того, как адрес попадёт в
 * историю или закладки. Два места:
 *  • `/m/launch#<код>` — окно ведущего встречи;
 *  • `/crm/recordings/<id встречи>#<код>` — страница записи встречи;
 *  • `/crm/chat/<id встречи>#<код>` — страница переписки встречи.
 *
 * Модуль импортируется в main.ts первым: роутер при создании запоминает адрес
 * вместе с фрагментом и при первой навигации записал бы его обратно.
 */
const LAUNCH_PATH = '/m/launch'
const VIEW_PATH = /^\/crm\/(recordings|chat)\/\d+\/?$/

let captured = ''
let capturedView = ''

function capture(): void {
  try {
    const path = window.location.pathname
    if (window.location.hash.length < 2) return
    if (path === LAUNCH_PATH) captured = window.location.hash.slice(1)
    else if (VIEW_PATH.test(path)) capturedView = window.location.hash.slice(1)
    else return
    window.history.replaceState(window.history.state, '', path + window.location.search)
  } catch {
    // history недоступна — код останется в адресе, погашение всё равно одноразовое
  }
}

/** Код отдаётся один раз: повторная загрузка окна идёт по cookie сессии. */
export function takeLaunchCode(): string {
  const code = captured
  captured = ''
  return code
}

/** Код страницы записи или переписки — тоже один раз; дальше страница живёт по cookie просмотра. */
export function takeViewCode(): string {
  const code = capturedView
  capturedView = ''
  return code
}

capture()
